/**
 * The customer's own redirect / copy link page. Fully sandboxed — it is static
 * decoration, every interactive part of the flow lives outside the iframe.
 */
export function RedirectHtmlFrame({ html }: { html: string }) {
  return (
    <iframe
      srcDoc={html}
      sandbox=""
      className="fixed inset-0 h-full w-full border-0"
      title="Redirect page"
    />
  );
}
